@if (showNotification) {
    <div class="header-update-warning">
        <span>TTMS Fuel Dispenser has been updated with new features.</span>
        &nbsp;
        <a
            href="#"
            (click)="hardReload()"
            class="header-update-button"
        >
            Click here to reload the page.
        </a>
    </div>
}
